import { webSocketActions as actions } from '../actions/websocket.actions';
import io from 'socket.io-client';
import { websocketConstants } from '../constants';
import { getAuthToken } from '../helpers/authHeader';

const socketMiddleware = () => {
  let socket: any = null;
  let onevent: any;

  const onOpen = (store) => () => {
    console.info('websocket open');
    store.dispatch(actions.wsConnected(socket.id));
  };

  const onClose = (store) => () => {
    console.info(`websocket close`);
    store.dispatch(actions.wsDisconnected(socket.id));
  };

  const onConnectError = (store) => ({ message }) => {
    console.info(`websocket error`, message);

    store.dispatch(actions.wsConnectError(message));
  };

  const onEvent = (store) => ({ msg, data }) => {
    const p = data;
    console.debug(
      'websocket receiving server message. event: ',
      msg,
      p,
    );
    store.dispatch(actions.wsOnEvent(msg, p));
  };

  // the middleware part of this function
  return (store) => (next) => (action) => {
    switch (action?.type) {
      case websocketConstants.WS_CONNECT:
        if (socket !== null) {
          socket.disconnect();
        }

        // connect to the remote host
        socket = io(action.payload?.host, {
          path: action.payload?.path,
          transports: ['websocket'],
          // @ts-ignore
          auth: {
            token: getAuthToken(),
          },
          reconnection: true, // default setting at present
          reconnectionDelay: 5000, // default setting at present
          reconnectionDelayMax: 10000, // default setting at present
          reconnectionAttempts: 10, // default setting at present
        });
        console.debug('in socketMiddleware wsConnect', socket);
        onevent = socket.onevent;

        // websocket handlers
        // socket.onmessage = onMessage(store);
        socket.on('connect', onOpen(store));
        socket.on('disconnect', onClose(store));
        socket.on('connect_error', onConnectError(store));
        socket.onevent = function (packet) {
          var args = packet.data || [];
          onevent.call(this, packet); // original call
          packet.data = ['*'].concat(args);
          onevent.call(this, packet); // additional call to catch-all
        };
        socket.on('*', function (msg, data) {
          console.debug('websocket * event', msg);
          console.debug('websocket * data', data);
          onEvent(store)({ msg, data });
        });

        break;
      case websocketConstants.WS_DISCONNECT:
        console.debug('in socketMiddleware wsDisConnect');
        if (socket !== null) {
          socket.disconnect();
        }
        socket = null;
        console.info('websocket closed');
        break;
      case websocketConstants.WS_EMIT:
        console.info(
          'websocket emit a message',
          action.payload?.msg,
          action.payload?.data,
        );
        socket.emit(action.payload?.msg, action.payload?.data);
        break;
      case websocketConstants.WS_EVENT:
        console.info('websocket onEvent. payload', action.payload);
        break;
      default:
        // console.log('the next action:', action);
        return next(action);
    }
  };
};

export default socketMiddleware();
